<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component({})
export default class SpaceTagsHelpIcon extends Vue {
  @Prop()
  modal: string

  open = false
}
</script>

<template>
  <span>
    <font-awesome-icon @click="open = true" icon="info-circle" class="fa-fw cursor-pointer" />

    <b-modal v-model="open" centered>
      <h2 class="mb-4">Tags Key</h2>

      <p>
        <b>Recent Emergency</b> - The Care Recipient has had at least one emergency within the last
        3 days. This tag will be removed once the Care Recipient doesn’t have any emergency events
        within the last 3 days.
      </p>
      <p>
        <b>Fall Risk</b> - This care recipient has a high fall risk based on factors such as recent
        emergencies, falls, and other events.
      </p>
      <p>
        <b>UTI Risk</b> - There has been an increase in bathroom visits versus the average typically
        seen in this Care Space, which may be indicative of a urinary tract infection (UTI).
      </p>
      <p>
        <b>Dehydration Risk</b> - There has been a decrease in bathroom visits versus the average
        typically seen in this Care Space, which may be indicative of dehydration.
      </p>

      <template #modal-footer="{ok}">
        <b-button @click="ok()" variant="primary" class="btn-block btn-lg">Okay</b-button>
      </template>
    </b-modal>
  </span>
</template>

<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';

p {
  font-size: 120%;
  color: $body-color;
}
</style>
